import { environment } from "../../environments/environment";

export class Urls {
  static baseUrl = environment.apiUrl;
  static integrationsUrl = environment.integrationsUrl;
  static accountonIntegrationsUrl = environment.accountonIntegrationsUrl;
  static authenticationServiceUrl = environment.authenticationUrl;
  static auth = `${Urls.authenticationServiceUrl}login`;
  static logOut = Urls.baseUrl + "auth/logout/";
  static TFA = Urls.authenticationServiceUrl + "2FA/";
  static basenet = Urls.baseUrl + "basenet";
  static customer = Urls.baseUrl + "customer/";
  static upload_customer_excel = Urls.customer + "import-customer-excel";
  static import_customer = Urls.customer + "import/";
  static customerFilterOptionsPath = "customer/filter-options";
  static download_contract = Urls.baseUrl + "transcript/download/";
  static document = Urls.baseUrl + "contract-bot-v2";
  static contract = Urls.baseUrl + "chat-flow/";
  static documentStep = Urls.baseUrl + "step/";
  static contract_upload = Urls.baseUrl + "chat-flow/contract/upload";
  static lawyers = Urls.baseUrl + "user/all/";
  static legal = Urls.baseUrl + "legal-topic/main/";
  static legal_branch = Urls.baseUrl + "legal-branch/";
  static legal_issue = Urls.baseUrl + "legal-issue/";
  static forgot = Urls.baseUrl + "auth/forget-password";
  static contract_analytics = Urls.baseUrl + "analytic/contract-bot";
  static web_common_analytics = Urls.baseUrl + "analytic/web/common";
  static anaylytics = Urls.baseUrl + "analytic/";
  static web_Flow = Urls.baseUrl + "chat-flow/web";
  static introduction_Flow = Urls.baseUrl + "chat-flow/web/introduction";
  static closing_Flow = Urls.baseUrl + "chat-flow/web/closing/";
  static chatFlow = Urls.baseUrl + "chat-flow/template";
  static chatFlow_analysis = Urls.baseUrl + "chat-flow/analysis";
  static training = Urls.baseUrl + "legal-topic";
  static topics = Urls.training + "/leaf-topic";
  static dailogFlow = Urls.baseUrl + "dialogflow/";
  static firm = Urls.baseUrl + "law-firm/";
  static entity = Urls.baseUrl + "dialogflow/" + "entity";
  static intent = Urls.dailogFlow + "intent/";
  static folder = Urls.dailogFlow + "folder/";
  static GDPR = Urls.baseUrl + "audit/";
  static mail_confirmation = Urls.baseUrl + "schedule/confirm";
  static label = Urls.baseUrl + "label";
  static quiz = Urls.baseUrl + "quiz/";
  static quizInviteCustomerExcelUpload = Urls.baseUrl + "quiz/quiz-invite-excel";
  static quizInviteCustomer = Urls.baseUrl + "quiz/invite";
  static quizStep = Urls.baseUrl + "quiz-step/";
  static ESigning = Urls.baseUrl + "e-signature/";
  static emailContent = Urls.baseUrl + "email-content/";
  static emailDesign = Urls.baseUrl + "email-design/";
  static minfin = Urls.baseUrl + "minfin/";
  static transcript = `${Urls.baseUrl}transcript/`;
  static otbCompany = `${Urls.integrationsUrl}otb/company`;
  static repeat_rule = `${Urls.baseUrl}repeat-rule`;
  static checkAzureSSO = `${Urls.authenticationServiceUrl}azuresso`;
  static authenticateAzure = `${Urls.checkAzureSSO}/callback`;
  static delegatedUsers = `${Urls.authenticationServiceUrl}delegation/users`;
  static delegationStart = (targetUserId: string): string => `${Urls.delegatedUsers}/${encodeURIComponent(targetUserId)}/start`;
  static delegationEnd = `${Urls.authenticationServiceUrl}delegation/end`;
  static search = `${Urls.customer}relation/list`;
  static reviewWorkflowPath = "review-workflow";
  static reviewWorkflowAssigneeOptionsPath = `${Urls.reviewWorkflowPath}/assignee-options`;
  static reviewWorkflowTaskCategoriesPath = `${Urls.reviewWorkflowPath}/task-categories`;
  static reviewWorkflowForTaskCategoryPath = `${Urls.reviewWorkflowPath}/for-task-category`;
  static reviewWorkflowAssigneeOptionsForTaskPath = (transcriptId: string): string =>
    `${Urls.reviewWorkflowPath}/assignee-options/for-task/${encodeURIComponent(transcriptId)}`;
  /** Resolves a workflow's steps against a customer before any task exists, unlike the instance-scoped form. */
  static reviewWorkflowAssignmentFormPath = (workflowId: string): string =>
    `${Urls.reviewWorkflowPath}/${encodeURIComponent(workflowId)}/assignment-form`;

  static monitoringPath = "monitoring";
  static monitoringListPath = `${Urls.monitoringPath}/list`;
  static monitoringCustomerListPath = (customerId: string): string =>
    `${Urls.monitoringPath}/customer/${encodeURIComponent(customerId)}/list`;
  static monitoringCustomerBadgesPath = (customerId: string): string =>
    `${Urls.monitoringPath}/customer/${encodeURIComponent(customerId)}/badges`;
  static monitoringCustomerWarningChecksPath = (customerId: string): string =>
    `${Urls.monitoringPath}/customer/${encodeURIComponent(customerId)}/warning-checks`;
  static monitoringCustomerFilterOptionsPath = `${Urls.monitoringPath}/filter-options/customers`;
  static monitoringAssigneeOptionsPath = (customerId: string): string =>
    `${Urls.monitoringPath}/customer/${encodeURIComponent(customerId)}/assignee-options`;
  static monitoringEventAssigneePath = (eventId: string): string => `${Urls.monitoringPath}/${encodeURIComponent(eventId)}/assignee`;
  static monitoringEventPath = (eventId: string): string => `${Urls.monitoringPath}/${encodeURIComponent(eventId)}`;
  static monitoringEventReviewPath = (eventId: string): string => `${Urls.monitoringPath}/${encodeURIComponent(eventId)}/review`;
  static monitoringEventCommentsPath = (eventId: string): string => `${Urls.monitoringPath}/${encodeURIComponent(eventId)}/comments`;

  static reviewWorkflowInstancePath = "review-workflow-instance";
  static reviewWorkflowInstanceByTranscriptPath = (transcriptId: string): string =>
    `${Urls.reviewWorkflowInstancePath}/by-transcript/${encodeURIComponent(transcriptId)}`;
  static reviewWorkflowInstanceAssignToPath = (transcriptId: string): string =>
    `${Urls.reviewWorkflowInstancePath}/assign-to/${encodeURIComponent(transcriptId)}`;
  static reviewWorkflowInstanceAssignmentPreviewPath = (transcriptId: string): string =>
    `${Urls.reviewWorkflowInstancePath}/assign-to/${encodeURIComponent(transcriptId)}/assignment-form`;
  static reviewWorkflowInstanceStepAssigneesPath = (instanceId: string, stepId: string): string =>
    `${Urls.reviewWorkflowInstancePath}/${encodeURIComponent(instanceId)}/steps/${encodeURIComponent(stepId)}/assignees`;
  static reviewWorkflowInstanceNotifyOnCompletePath = (instanceId: string): string =>
    `${Urls.reviewWorkflowInstancePath}/${encodeURIComponent(instanceId)}/notify-on-complete`;
  static reviewWorkflowInstanceStepActionPath = (
    instanceId: string,
    stepId: string,
    action: "start" | "approve" | "reject" | "resolve"
  ): string => `${Urls.reviewWorkflowInstancePath}/${encodeURIComponent(instanceId)}/steps/${encodeURIComponent(stepId)}/${action}`;
  static reviewWorkflowInstanceSigningRetryPath = (instanceId: string, stepId: string): string =>
    `${Urls.reviewWorkflowInstancePath}/${encodeURIComponent(instanceId)}/steps/${encodeURIComponent(stepId)}/signing/retry`;
  static reviewWorkflowInstanceAssignedToMePath = `${Urls.reviewWorkflowInstancePath}/assigned-to-me`;
  static transcriptAnswersPath = (transcriptId: string): string => `transcript/${encodeURIComponent(transcriptId)}/answers`;
  static transcriptArchivePath = "transcript/archive";
  static minfinMaster = environment.minfinMasterUrl;
}
